/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityCanvasControls = ({ currentStage, cardWidth, cardHeight, setStageProperties, setCurrentStage }) => {
    // Function to handle button click, toggling the current stage between 1 and 2
    const handleButtonClick = () => {
        setCurrentStage((prevStage) => (prevStage === 1 ? 2 : 1));
    };
    // Toggles the orientation between 'vertical' and 'horizontal' for the current stage
    const toggleOrientation = () => {
        setStageProperties((prevProperties) => {
            const currentProperties = prevProperties[currentStage];
            const newOrientation = currentProperties.orientation === 'vertical' ? 'horizontal' : 'vertical';

            return {
                ...prevProperties,
                [currentStage]: {
                    ...currentProperties,
                    orientation: newOrientation,
                    width: newOrientation === 'vertical' ? cardWidth : cardHeight,
                    height: newOrientation === 'vertical' ? cardHeight : cardWidth,
                },
            };
        });
    };
    return { toggleOrientation, handleButtonClick };
};
export default FunctionalityCanvasControls;
